import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const ArrowRight = (props: IconProps) => (
  <SvgIcon size={props.size}>
    <path
      d="M15.49 5l7.01 7.011-7.01 7.01M22 12.021H0"
      stroke="currentColor"
      strokeWidth="2"
    />
  </SvgIcon>
);

export default ArrowRight;
